import { Component, Input, OnInit } from '@angular/core';

import { Tutor } from '../../models/tutor.model';

@Component({
    selector: 'app-tutor-detail',
    templateUrl: './tutor-detail.component.html',
    styleUrls: [ './tutor-detail.component.scss' ]
})
export class TutorDetailComponent implements OnInit {

    @Input() tutor: Tutor;

    constructor() { }

    ngOnInit() { }

}
